import { render, staticRenderFns } from "./RmrStatusChip.vue?vue&type=template&id=89fcf180&scoped=true&"
import script from "./RmrStatusChip.vue?vue&type=script&lang=js&"
export * from "./RmrStatusChip.vue?vue&type=script&lang=js&"
import style0 from "./RmrStatusChip.vue?vue&type=style&index=0&id=89fcf180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fcf180",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
